import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { trpc } from '@/lib/trpc';
import { OfficeManagerBoard } from '@/components/office-manager/OfficeManagerBoard';
import { KitsModule } from '@/components/kits/KitsModule';
import { useTranslation } from 'react-i18next';

/**
 * Página standalone para Office Managers configuradas por governance que NO
 * tienen roles ni tab:users (la ruta vive fuera del bloque protegido de users).
 * Para quienes sí ven la sección Users, lo mismo aparece como tabs dentro de
 * "Oficinas". Tabs: Entregas (equipos) | Kits (stock de kits de onboarding).
 */
export function OfficeManagerPage() {
  const { t } = useTranslation();
  const { data: kitsAccess } = trpc.kits.getMyAccess.useQuery(undefined, {
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold tracking-tight">{t('admin.officemanager.office_manager')}</h2>
        <p className="text-muted-foreground">{t('admin.officemanager.entrega_de_equipos_y_stock_de')}</p>
      </div>

      <Tabs defaultValue="entregas">
        <TabsList>
          <TabsTrigger value="entregas">Entregas</TabsTrigger>
          {kitsAccess?.canView && <TabsTrigger value="kits">Kits</TabsTrigger>}
        </TabsList>
        <TabsContent value="entregas" className="mt-4">
          <OfficeManagerBoard />
        </TabsContent>
        {kitsAccess?.canView && (
          <TabsContent value="kits" className="mt-4">
            <KitsModule />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
